const defaultDateTimeFormat = 'YYYY-MM-DD HH:mm:ss ZZ'

export default defaultDateTimeFormat
